var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"container content-padding"},[_c('PaginatedBlogPosts',{attrs:{"topic-filters":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }